import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Hook partagé pour gérer le statut d'essai du restaurant
 * Calcule les jours restants et détermine si l'essai est expiré
 */
export const useTrialStatus = () => {
  const { user, isAdmin, api } = useAuth();
  const [restaurantInfo, setRestaurantInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.restaurant_id) {
      // Utiliser l'endpoint /restaurant/plan accessible à tous les utilisateurs
      const endpoint = isAdmin ? '/restaurant/settings' : '/restaurant/plan';
      api.get(endpoint)
        .then(r => {
          setRestaurantInfo({
            created_at: r.data.created_at,
            plan: r.data.plan,  // "free", "pro", "plus"
            subscription_status: r.data.subscription_status
          });
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [user?.restaurant_id, isAdmin, api]);

  const calculateTrialDaysLeft = () => {
    if (!restaurantInfo || !restaurantInfo.created_at) {
      return null;
    }
    
    // Si le restaurant a un plan payant actif, pas de trial
    if (restaurantInfo.plan && restaurantInfo.plan !== 'free') {
      return null;
    }
    
    const createdDate = new Date(restaurantInfo.created_at);
    const now = new Date();
    const daysSinceCreation = Math.floor((now - createdDate) / (1000 * 60 * 60 * 24));
    const daysLeft = Math.max(0, 14 - daysSinceCreation);
    
    return daysLeft;
  };

  const trialDaysLeft = calculateTrialDaysLeft();
  const isTrialExpired = trialDaysLeft === 0;
  const isTrialActive = trialDaysLeft !== null && trialDaysLeft > 0;
  const isPro = restaurantInfo?.plan && restaurantInfo.plan !== 'free';

  return {
    trialDaysLeft,
    isTrialExpired,
    isTrialActive,
    isPro,
    restaurantInfo,  // Exposer restaurantInfo pour useFeatureAccess
    loading,
    showTrialBanner: trialDaysLeft !== null && isAdmin
  };
};
